import React, { useMemo, useState } from 'react';
import { EMOJI_CATEGORIES, getEmojiList } from '../data/emoji';
import ArrowNavigationGrid from './ArrowNavigationGrid';
import { Button, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { buttonKeyId } from '../utils/emojiUtils';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import getMessage from '../utils/getMessage';

const EmojiSelector = ({ selectionHandler }) => {
  const [tab, setTab] = useState(EMOJI_CATEGORIES[0].id);
  const [modifier, setModifier] = useState("0");

  const emojiArrays = useMemo(() => {
    const arraysObject = {};
    for (const ec of EMOJI_CATEGORIES) {
      if (ec.modifiers) {
        arraysObject[ec.id] = ec.modifiers.map(m => getEmojiList(ec, m));
      } else {
        arraysObject[ec.id] = getEmojiList(ec, null);
      }
    }
    return arraysObject;
  }, [])

  const selectCategory = (_event, newValue) => {
    setTab(newValue)
    setModifier("0")
  };

  const selectEmoji = (emoji) => {
    selectionHandler(emoji);
  };

  const NULL_MODIFIER_SYMBOL = '-';

  return (
    <div className="emoji-input">
      <FormLabel>
        <FormattedMessage id="emojiAddToComment" />
      </FormLabel>
      <TabContext value={tab}>
        <TabList onChange={selectCategory}>
            {EMOJI_CATEGORIES.map((ec, i) => (
              <Tab key={`tab_${ec.id}`} label={getMessage(ec.id)} value={ec.id} />
            ))}
        </TabList>
        { EMOJI_CATEGORIES.map((ec, i) => (
          <TabPanel key={`tabpanel_${ec.id}`} value={ec.id}>
            {ec.modifiers ? ( // Make inner tabs for emoji modifiers if the category has them
              <div>
                <TabContext value={modifier}>
                  <TabList onChange={(e, nv) => setModifier(nv)}>
                    {ec.modifiers.map((mod, i) => (
                      <Tab key={`tab_${ec.id}_mod_${mod}`} 
                        label={mod
                          ? String.fromCodePoint(parseInt(mod, 16))
                          : NULL_MODIFIER_SYMBOL
                        } 
                        value={""+i} 
                      />
                    ))}
                  </TabList>
                  {ec.modifiers.map((mod, i) => (
                    <TabPanel key={`tabpanel_${ec.id}_mod_${mod}`} value={""+i}>
                      <ArrowNavigationGrid
                        buttonKey="emoji"
                        escapeId="button-emojis"
                        max={emojiArrays[ec.id][i].length - 1}
                      >
                        {emojiArrays[ec.id][i].map((emoji, j) => (
                          <Button
                            key={`emoji-${emoji}`}
                            id={buttonKeyId('emoji', j)}
                            className="emoji"
                            onClick={() => {
                              selectEmoji(emoji);
                            }}
                            tabIndex={j>0 ? -1 : undefined}
                          >
                            {emoji}
                          </Button>
                        ))}
                      </ArrowNavigationGrid>
                    </TabPanel>

                  ))}

                </TabContext>
              </div>
            ) : // No categories, just draw the grid
            <ArrowNavigationGrid
              buttonKey="emoji"
              escapeId="button-emojis"
              max={emojiArrays[ec.id].length - 1}
            >
              {emojiArrays[ec.id].map((emoji, i) => (
                <Button
                  key={`emoji-${emoji}`}
                  id={buttonKeyId('emoji', i)}
                  className="emoji"
                  onClick={() => {
                    selectEmoji(emoji);
                  }}
                  tabIndex={i>0 ? -1 : undefined}
                >
                  {emoji}
                </Button>
              ))}
            </ArrowNavigationGrid>
            }
          </TabPanel>
        ))}
      </TabContext>
    </div>
  );
};

export default EmojiSelector;